<template>
  <el-popconfirm title="确定要退出吗？" @confirm="logout">
    <el-button
      type="text"
      slot="reference"
      icon="el-icon-switch-button"
    ></el-button>
  </el-popconfirm>
</template>

<script>
import { Popover, Popconfirm, Button } from "element-ui";
export default {
  name: "LogoutButton",
  components: {
    [Popover.name]: Popover,
    [Popconfirm.name]: Popconfirm,
    [Button.name]: Button,
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
